import compareAsc from 'date-fns/compare_asc'

type Event = {
  status: string
  date: string
}

type Order = {
  userId: number
  cancelled: boolean
  isShipped: boolean
}

export const canRequestReplacements = (userId: number | undefined, event: Event, order: Order) => {
  if (!userId || !event || !order) return false

  try {
    const isUserOrder = userId === order.userId
    const isEventUpcoming = event.status === 'booked'
    const {cancelled: isCancelled, isShipped} = order
    const hasEventDatePassed = compareAsc(new Date(event.date), new Date()) <= 0

    return Boolean(
      isUserOrder && isEventUpcoming && !isCancelled && isShipped && !hasEventDatePassed,
    )
  } catch (err) {
    console.error(err)
    return false
  }
}
